<ion-header>
	<ion-toolbar>
		<ion-title i18n=":@@account_crud.page_title">A minha conta</ion-title>
		<ion-buttons slot="start">
			<ion-back-button></ion-back-button>
		</ion-buttons>

	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding padding-horizontal">

	<ion-grid>
		<ion-row>
			<ion-card class="ion-no-margin ion-no-padding full">
				<ion-card-header>
					<ion-card-title>Dados Pessoais</ion-card-title>
				</ion-card-header>

				<ion-card-content>

					<form [formGroup]="Form">
						<ion-row>
							<ion-col>
								<ion-item class="full" lines="full" fill="outline">
									<ion-label position="stacked" i18n=":@@account_crud.name" required>Nome
									</ion-label>
									<ion-input formControlName="Name"></ion-input>
								</ion-item>

								<form-errors [control]="Form.get('Name')"></form-errors>
							</ion-col>
						</ion-row>

						<ion-row>

							<ion-col>
								<ion-item class="full" lines="full" fill="outline">
									<ion-label position="stacked" i18n=":@@account_crud.username">Nome perfil
									</ion-label>
									<ion-input formControlName="Username"></ion-input>
								</ion-item>
								<form-errors [control]="Form.get('Username')"></form-errors>

							</ion-col>

							<ion-col>
								<ion-item class="full" lines="full" fill="outline" formGroupName="Template">
									<ion-label position="stacked" i18n=":@@account_crud.user-role">Perfil
										utilizador
									</ion-label>
									<ion-input formControlName="Name"></ion-input>
								</ion-item>

								<form-errors [control]="Form.get('Template').get('Id')"></form-errors>
							</ion-col>
						</ion-row>

						<ion-row>
							<ion-col>
								<ion-item class="full" lines="full" fill="outline">
									<ion-label position="stacked" i18n=":@@account_crud.email">Endereço email
									</ion-label>
									<ion-input formControlName="Email"></ion-input>
								</ion-item>
								<form-errors [control]="Form.get('Email')"></form-errors>
							</ion-col>
						</ion-row>

						<ion-row *ngIf="IsCompleted">
							<ion-col class="ion-justify-content-end display-flex">

								<ng-container *ngIf="Form.enabled">

									<ion-button fill="solid" color="medium" title="Cancelar" (click)="OnCancelEdit()">
										<ion-icon slot="icon-only" name="close-outline">
										</ion-icon>
										<!-- <ng-container i18n=":@@account_crud.cancel">Cancelar</ng-container> -->
									</ion-button>

									<ion-button fill="solid" color="primary" title="Guardar" (click)="OnSave()">
										<!-- <ion-icon slot="icon-only" name="save-outline"></ion-icon> -->
										<ng-container i18n=":@@account_crud.save">Guardar</ng-container>
									</ion-button>
								</ng-container>

								<ng-container *ngIf="Form.disabled">

									<ion-button [disabled]="FormPassword.enabled" fill="solid" color="medium"
										title="Editar" (click)="OnEdit()">
										<!-- <ion-icon slot="icon-only" name="create-outline"></ion-icon> -->
										<ng-container i18n=":@@account_crud.edit">Editar</ng-container>
									</ion-button>
								</ng-container>

							</ion-col>
						</ion-row>

					</form>
				</ion-card-content>
			</ion-card>
		</ion-row>


		<ion-row class="ion-margin-top">
			<ion-card class="ion-no-margin ion-no-padding full">

				<ion-card-header>
					<ion-card-title>Alterar palavra-passe</ion-card-title>
				</ion-card-header>

				<ion-card-content>

					<form [formGroup]="FormPassword">
						<ion-row>
							<ion-col size="12" sizeMd="6">
								<ion-item class="full">
									<ion-label position="stacked">Palavra-passe atual</ion-label>
									<password-toggle>
										<ion-input placeholder="Palavra-passe" type="password"
											formControlName="PasswordOld">
										</ion-input>
									</password-toggle>
								</ion-item>
								<!-- <form-errors [control]="Form.get('Password')"></form-errors> -->
							</ion-col>
						</ion-row>

						<ion-row>

							<ion-col size="12" sizeMd="6">
								<ion-item class="full">
									<ion-label position="stacked">Nova palavra-passe</ion-label>
									<password-toggle>
										<ion-input placeholder="Palavra-passe" type="password"
											formControlName="Password">
										</ion-input>
									</password-toggle>
								</ion-item>
								<!-- <form-errors [control]="Form.get('Password')"></form-errors> -->
							</ion-col>

							<ion-col size="12" sizeMd="6">
								<ion-item class="full">
									<ion-label position="stacked">Confirmar palavra-passe</ion-label>
									<password-toggle>
										<ion-input placeholder="Palavra-passe" type="password"
											formControlName="PasswordMatch">
										</ion-input>
									</password-toggle>
								</ion-item>

								<!-- <form-errors [control]="Form.get('PasswordMatch')"></form-errors> -->

							</ion-col>

						</ion-row>

						<ion-row *ngIf="IsCompleted">
							<ion-col class="ion-justify-content-end display-flex">
								<ion-button *ngIf="FormPassword.disabled" [disabled]="Form.enabled" color="medium"
									(click)="OnEditPassword($event)">Alterar</ion-button>

								<ng-container *ngIf="FormPassword.enabled">
									<ion-button color="medium" (click)="OnCancelPassword($event)">
										<ion-icon slot="icon-only" name="close-outline"></ion-icon>
									</ion-button>

									<ion-button color="primary" (click)="OnChangePassword($event)">Guardar</ion-button>

								</ng-container>
							</ion-col>
						</ion-row>

					</form>
				</ion-card-content>
			</ion-card>
		</ion-row>
	</ion-grid>

</ion-content>